import { Ban } from 'lucide-react'

interface DeletedMessageProps {
  direction: 'in' | 'out'
}

export function DeletedMessage({ direction }: DeletedMessageProps) {
  const isOutgoing = direction === 'out'

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-lg ${
        isOutgoing
          ? 'bg-gray-100 text-gray-500'
          : 'bg-gray-50 text-gray-400'
      }`}
    >
      <Ban className="h-4 w-4 flex-shrink-0" />
      <span className="text-sm italic">
        {isOutgoing ? 'Eliminaste este mensaje' : 'Este mensaje fue eliminado'}
      </span>
    </div>
  )
}
